export default [
    {
        path: 'fenceline',
        name: 'Report',
        redirect : "Report",
    },
    {
        path: 'Report',
        name: 'Report',
        component: () => import(/* webpackChunkName: "fenceline-Report" */ '../views/Report.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    /*{
        path: 'Report/CVO',
        name: 'Report',
        component: () => import(/* webpackChunkName: "fenceline-Report" */ /*'../views/Report.vue'),
        /*meta: {/*
            mainNavEnabled: false,
        },
    },
    {
        path: 'Report/CCO',
        name: 'Report',
        component: () => import(/* webpackChunkName: "fenceline-Report" */ /*'../views/Report.vue'),
        /*meta: {/*
            mainNavEnabled: false,
        },
    },
    {
        path: 'Report/CLO',
        name: 'Report',
        component: () => import(/* webpackChunkName: "fenceline-Report" */ /*'../views/Report.vue'),
        /*meta: {/*
            mainNavEnabled: false,
        },
    },
    {
        path: 'Report/LPO',
        name: 'Report',
        component: () => import(/* webpackChunkName: "fenceline-Report" */ /*'../views/Report.vue'),
        /*meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'Report/CCO',
        name: 'Report',
        component: () => import(/* webpackChunkName: "fenceline-Report" */ /*'../views/Report.vue'),
        /*meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'Report/MIO',
        name: 'Report',
        component: () => import(/* webpackChunkName: "fenceline-Report" */ /*'../views/Report.vue'),
        /*meta: {
            mainNavEnabled: false,
        },
    },
   /* {
        path: 'Report',
        name: 'Report',
        component: () => import(/* webpackChunkName: "fenceline-SiteList" */ /*'../views/SiteList.vue'),
        meta: {
            mainNavEnabled: false,
        },
    }*/
    /*{
        path: 'site/:code',
        name: 'Site',
        component: () => import(/* webpackChunkName: "fenceline-help" *//* '../views/Site.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },*/
]
